import { EmployeeDependentMutationDTO } from "../../models/employee-dependents/mutations/employee-dependent-mutation-dto";
import { EmployeeDependentMutationSTO } from "../../models/employee-dependents/mutations/employee-dependent-mutation-sto";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeDependentMutationsApiService extends BaseApiService<
  EmployeeDependentMutationDTO,
  EmployeeDependentMutationSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeDependentMutations",
      loadItemsPath: "/GetEmployeeDependentMutations",
      saveItemsPath: "/SaveEmployeeDependentMutations",
    });
  }
}
